import { expVal } from '@atlassian/jira-feature-experiments';
import { gqlTagGira } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/gira-fragments/index.tsx';

const getFieldItemOptionsFragment = () =>
	expVal(
		'thor_colourful_single_select_milestone2_experiment',
		'isColorfulSingleSelectEnabled',
		false,
	)
		? gqlTagGira`fragment FieldItemOptionsFragment on JiraIssueLayoutFieldOption {
			value
			id
			externalUuid
			parentId
			color { colorKey }
		}`
		: gqlTagGira`fragment FieldItemOptionsFragment on JiraIssueLayoutFieldOption {
		value
		id
		externalUuid
		parentId
	}`;
export const FieldItemOptionsFragment = getFieldItemOptionsFragment();

export const FieldItemProviderFragment = gqlTagGira`
fragment FieldItemProviderFragment on JiraIssueLayoutFieldProvider {
  key
  name
}
`;

export const FieldItemOperationsFragment = gqlTagGira`
fragment FieldItemOperationsFragment on JiraIssueLayoutFieldOperations {
  editable
  canModifyRequired
  canModifyOptions
  canModifyDefaultValue
  canModifyPropertyConfiguration
  removable
  deletable
  canAssociateInSettings
  categoriesWhitelist
}
`;

export const FieldItemBaseFragment = gqlTagGira`
fragment FieldItemBaseFragment on JiraIssueLayoutFieldItemConfiguration {
  fieldItemId
  key
  name
  type
  custom
  global
  description
  configuration
  required
  externalUuid
  defaultValue
  options {
    ...FieldItemOptionsFragment
  }
  operations {
    ...FieldItemOperationsFragment
  }
  provider {
    ...FieldItemProviderFragment
  }
  availability {
    isHiddenIn {
      __typename
      ... on JiraIssueLayoutFieldConfigurationHiddenInGlobal {
        fieldConfigs {
          id
          configName
        }
      }
      ... on JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner {
        layoutOwnerId
        fieldConfigs {
          id
          configName
        }
      }
    }
    context {
      layoutOwnerIds
      id
    }
    displayConditions
    isHiddenByAppAccessRules
  }
}
`;

export const FieldItemFragment = gqlTagGira`
  ${FieldItemOperationsFragment}
  ${FieldItemProviderFragment}
  ${FieldItemBaseFragment}
  ${FieldItemOptionsFragment}
  fragment FieldItemFragment on JiraIssueLayoutFieldItemConfiguration {
    ...FieldItemBaseFragment
    properties(keys: $fieldPropertyKeys)
  }
`;

export const PanelItemFragment = gqlTagGira`
fragment PanelItemFragment on JiraIssueLayoutPanelItemConfiguration {
  panelItemId
  name
  operations {
      editable
      removable
      categoriesWhitelist
      canAssociateInSettings
      deletable
  }
}`;

export const LayoutOwnersFragment = gqlTagGira`
fragment JiraIssueLayoutOwnerFragment on JiraIssueLayoutOwner {
  __typename
  ... on JiraIssueLayoutIssueTypeOwner {
    id
    name
    description
    avatarId
    iconUrl
  }
  ... on JiraIssueLayoutRequestTypeOwner {
    id
    externalUuid
    name
    description
    avatarId
    iconUrl
    instructions
    restrictionStatus
    properties(keys: $requestOwnerPropertyKeys)
  }
}
`;

export const JiraIssueLayoutUsageInfoFragment = gqlTagGira`
${LayoutOwnersFragment}
fragment JiraIssueLayoutUsageInfo on JiraIssueLayoutUsageInfoConnection {
  edges {
    currentProject
    node {
      avatarId
      projectId
      projectKey
      projectName
      layoutOwners {
        ... JiraIssueLayoutOwnerFragment
      }
    }
  }
}
`;

export const JiraIssueLayoutActiveFieldItemFragment = gqlTagGira`
  fragment JiraIssueLayoutActiveFieldItemFragment on JiraIssueItemFieldItem {
    __typename
    fieldItemId
    containerPosition
  }
`;

export const JiraIssueLayoutActivePanelItemFragment = gqlTagGira`
  fragment JiraIssueLayoutActivePanelItemFragment on JiraIssueItemPanelItem {
  __typename
    panelItemId
  }
`;

export const JiraIssueLayoutTabContainerFragment = gqlTagGira`
  ${JiraIssueLayoutActiveFieldItemFragment}
  fragment JiraIssueLayoutTabContainerFragment on JiraIssueItemTabContainer {
      __typename
      tabContainerId
      name
      items {
        nodes {
          ...JiraIssueLayoutActiveFieldItemFragment
        }
        totalCount
      }
  }
`;

export const JiraIssueLayoutItemContainerFragment = gqlTagGira`
${JiraIssueLayoutActivePanelItemFragment}
${JiraIssueLayoutTabContainerFragment}
fragment JiraIssueLayoutItemContainerFragment on JiraIssueItemContainer {
  containerType
  items {
    nodes {
      __typename
      ... JiraIssueLayoutActiveFieldItemFragment,
      ... JiraIssueLayoutActivePanelItemFragment,
      ... JiraIssueLayoutTabContainerFragment,
    }
  }
}
`;

export const AvailableLayoutItemGroupsFragments = gqlTagGira`
${PanelItemFragment}
${FieldItemFragment}

fragment SystemAvailableLayoutItemsGroup on JiraIssueLayoutFieldPanelItemConfigurationResult {
  items {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
          node {
              __typename
              ...FieldItemFragment
              ...PanelItemFragment
          }
      }
  }
}
fragment CustomAvailableLayoutItemsGroup on JiraIssueLayoutFieldItemConfigurationResult {
  items {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
          node {
              __typename
              ...FieldItemFragment
          }
      }
  }
}
`;

export const JiraIssueLayoutItemConfigurationFragment = gqlTagGira`
fragment JiraIssueLayoutItemConfigurationFragment on JiraIssueLayoutItemConfigurationResult {
  items {
    nodes {
      __typename
      ...FieldItemFragment
      ...PanelItemFragment
    }
  }
}
`;
